<template>
  <div v-loading="loading">
    <div v-if="treeList">
      <el-cascader
        v-model="inputValue"
        style="width: 100%"
        :options="treeList"
        :props="props"
        :disabled="disabled"
        :clearable="clearable"
        :editable="false"
        @change="handleInputConfirm"
      >
      </el-cascader>
    </div>
    <div v-else-if="!loading" style="margin-bottom: 10px">
      <div>
        <span style="color: #ff0000"> {{ errorMsg || "加载失败" }}</span>
      </div>
      <el-button v-if="errorMsg" @click="fetchTreeList" size="small">
        重新加载
      </el-button>
    </div>
  </div>
</template>

<style scoped>
.tag-item {
  margin-right: 10px;
}

.button-new-tag {
  margin-right: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  margin-right: 10px;
}
</style>

<script>
export default {
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      errorMsg: "",
      inputValue: [],
      treeList: null,
      props: {
        multiple: true,
        emitPath: false,
        value: "guid",
        label: "classifyName",
        children: "childrenList"
      },
    };
  },
  watch: {
    value() {
      this.initValue();
    }
  },
  mounted() {
    this.initValue();
    this.fetchTreeList();
  },
  methods: {
    initValue() {
      if (this.value) {
        this.inputValue = `${this.value}`.split(",");
      } else {
        this.inputValue = []
      }
    },
    fetchTreeList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.requestApi("biz.goods.classify.info.treeList", {}, {
        cache: 1, cacheCallback: (resp) => {
          this.handleFetchResp(resp);
        }
      }).then((resp) => {
        this.loading = false;
        this.handleFetchResp(resp);
      }).catch((err) => {
        this.loading = false;
        this.errorMsg = (err && err.msg) || (err && err.message)
          || "数据加载失败";
      });
    },
    handleFetchResp(resp) {
      this.treeList = resp.data || [];
      (this.treeList || []).forEach(item => {
        if (!item.childrenList || item.childrenList.length <= 0) {
          item.childrenList = [{
            guid: item.guid,
            classifyName: item.classifyName,
          }]
        }
      });
    },
    handleInputConfirm() {
      if (this.loading) {
        return;
      }
      if (this.inputValue && this.inputValue.length > 0) {
        this.$emit("change", this.inputValue.join(","));
      } else {
        this.$emit("change", "");
      }
    },
  },
};
</script>